module.exports = __webpack_public_path__ + "media/images/homepage/reason-6-42bfabe255ab4e0f7b1d5d16d1057f3e.png";